import { Injectable } from '@angular/core';
import { environment } from './../environments/environment';

@Injectable()
export class AppGlobals {
    readonly baseAPIUrl: string = environment.baseAPIUrl;
}
